(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-attachment-player]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const video = root.querySelector('video');
      const toggle = root.querySelector('[data-toggle]');
      const range = root.querySelector('input[type="range"]');
      const time = root.querySelector('.nc-magnetic__time');
      const chapters = [...root.querySelectorAll('[data-seek]')];
      if (!video || !toggle || !range) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let wanted = !reduced.matches;
      let visible = false;
      const label = t => t < 2.375 ? 'Bring close' : t < 4.125 ? 'Click on' : 'Lift away';
      function sync() {
        range.max = Number.isFinite(video.duration) ? video.duration : 6;
        range.value = video.currentTime;
        range.setAttribute('aria-valuetext', `${label(video.currentTime)}, ${video.currentTime.toFixed(1)} seconds`);
        toggle.textContent = video.paused ? 'Play' : 'Pause';
        toggle.setAttribute('aria-label', `${video.paused ? 'Play' : 'Pause'} animation`);
        if (time) time.textContent = `0:0${Math.floor(video.currentTime)} / 0:06`;
        const phase = video.currentTime < 2.375 ? 0 : video.currentTime < 4.125 ? 1 : 2;
        chapters.forEach((button, i) => button.setAttribute('aria-pressed', String(i === phase)));
      }
      function reconcile() {
        if (wanted && visible && !document.hidden) video.play().catch(() => { wanted = false; sync(); });
        else video.pause();
      }
      toggle.addEventListener('click', () => { touched = true; wanted = video.paused; reconcile(); });
      range.addEventListener('input', () => { touched = true; wanted = false; video.pause(); video.currentTime = Number(range.value); sync(); });
      chapters.forEach(button => button.addEventListener('click', () => { touched = true; wanted = false; video.pause(); video.currentTime = Number(button.dataset.seek); sync(); }));
      ['timeupdate', 'loadedmetadata', 'play', 'pause', 'seeked'].forEach(event => video.addEventListener(event, sync));
      document.addEventListener('visibilitychange', reconcile);
      reduced.addEventListener('change', () => { wanted = !reduced.matches; reconcile(); });
      let touched = false;
      const inView = e => e.isIntersecting && (e.intersectionRatio >= .6 || e.intersectionRect.height >= window.innerHeight * .5);
      const observer = new IntersectionObserver(entries => {
        const e = entries[0], now = inView(e);
        if (now && !visible && !touched && wanted) { video.currentTime = 0; }
        if (!e.isIntersecting && !touched) { video.pause(); video.currentTime = 0; }
        visible = now; reconcile();
      }, { threshold: [0, .25, .5, .6, .75, 1] });
      observer.observe(root);
      video.addEventListener('error', () => { wanted = false; toggle.disabled = true; range.disabled = true; toggle.textContent = 'Still'; });
      sync();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
